
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const vid = document.getElementById(this.blok.id)
      vid.playbackRate = parseFloat(this.blok.speed) || 1
    })
  },
}
